module.exports = __webpack_public_path__ + "app/themes/vwfs/sme-price-list-assets/img/daily-rental.42c9b27a.svg";